module.exports = __webpack_public_path__ + "static/ellen-armstrong-pic-2-f8d95f490934409c758bb44b0582b47f.jpg";